import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, Typography, Box } from '@mui/material';
import PageLayout from '../components/common/PageLayout';
import OrderEditView from '../components/orders/OrderEditView';

/**
 * Full-page order editor (replaces modal). Return path comes from location.state.returnTo.
 */
export default function OrderEditPage() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = location.state?.returnTo || '/orders';
  const id = parseInt(String(orderId), 10);

  if (!Number.isFinite(id) || id <= 0) {
    return (
      <PageLayout contentMaxWidth="lg" showHeaderImage={false} showOrgHeader>
        <Box sx={{ py: 2 }}>
          <Typography color="error" gutterBottom>
            Invalid order ID
          </Typography>
          <Button variant="contained" onClick={() => navigate(returnTo)}>
            Go back
          </Button>
        </Box>
      </PageLayout>
    );
  }

  return (
    <PageLayout contentMaxWidth="lg" showHeaderImage={false} showOrgHeader>
      <OrderEditView
        order={{ id }}
        returnTo={returnTo}
        onAddAnotherOrder={() => navigate('/post-payment')}
      />
    </PageLayout>
  );
}
